import React, { Component } from 'react'
import { connect } from 'react-redux'
import {FormContext, StyledForm} from 'components'
import { OrganisationActions, SnackbarActions } from 'actionsets'
import Dependent from 'containers/shared/Dependent'
import StyleSheet from 'styles'
import {humanize, uuid} from 'utils'
import CenteredContent from 'containers/CenteredContent'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Checkbox from 'components/styled/Checkbox'
import {IconButton} from 'components/OptimisedMui'
import DeleteIcon from '@material-ui/icons/Delete'
import Button from '@material-ui/core/Button'

export class SupportingDocuments extends Component {
  constructor(props) {
    super(props)
    OrganisationActions.bindActions(this)
    SnackbarActions.bindActions(this, 'snackbar')
    this.state = {
      context: {},
    }
  }

  get formContext() {
    return {...this.props.organisation, ...this.state.context}
  }

  dependsOn() {
    return this.actions.show()
  }

  dependenciesMet() {
    return this.props.organisation.id
  }

  handleAddDocument = tag => () => {
    const context = this.formContext
    this.setState({context: {...this.state.context, defaultDownloads: [...context.defaultDownloads, {key: uuid(), tag}]}})
  }

  handleDeleteDocument = item => () => {
    const context = this.formContext
    this.setState({context: {...this.state.context, defaultDownloads: context.defaultDownloads.filter(i => i !== item)}})
  }

  handleChange = context => {
    this.setState({context})
  }

  handleSave = async() => {
    try {
      await this.actions.update(this.formContext)
      this.actions.snackbar.show("Supporting Documents Saved")
    }
    catch (ex) {
      this.actions.snackbar.error("Could not save supporting documents")
    }
  }

  render = () =>
    <CenteredContent>
      <StyledForm style={{maxWidth: 553}}>
        <FormContext context={this.formContext} onChange={this.handleChange}>
          <Typography variant={'h5'}>Supporting Documents</Typography>

          {['individual', 'company', 'partnership', 'trust', 'aml'].map(entity =>
            <div className={styles.section}>
              <Typography variant='h6'>{humanize(entity)}</Typography>
              {this.formContext.defaultDownloads.map((item, i) =>
                item.tag === entity &&
                <div className={styles.document} key={i}>
                  <TextField member={`defaultDownloads[${i}].name`}/>
                  <Typography style={{display: 'inline-block'}}>
                    <Checkbox member={`defaultDownloads[${i}].required`}/> Required
                  </Typography>
                  <IconButton style={{float: 'right'}} onClick={this.handleDeleteDocument(item)}>
                    <DeleteIcon/>
                  </IconButton>
                </div>
              )}
              <Button className={styles.addButton} onClick={this.handleAddDocument(entity)} fullWidth>Add Another Document</Button>
            </div>
          )}


          <div className={styles.section}>
            <Button onClick={this.handleSave} variant='contained' color='primary' fullWidth>Save</Button>
          </div>
        </FormContext>
      </StyledForm>
    </CenteredContent>

}

const styles = StyleSheet({
  wrapper: {
    display: 'flex',
    flex: 1
  },
  section: {
    marginBottom: 50,
    position: 'relative'
  },
  addButton: {
    backgroundColor: '#b9b39b',
    color: 'white',
    marginBottom: 20,
    '&:hover': {
      backgroundColor: '#c2bca4',
    }
  },
  document: {
    display: 'flex',
    width: '100%',
    '& > :first-child': {
      flex: 1
    }
  }
})

export default connect(({organisations}) => (organisations))(Dependent({loader: true, wrapperClassName: styles.wrapper, clearOnLoad: true})(SupportingDocuments))